import React from 'react';
type LogoProps = {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  sub?: string;
};
const sizes = {
  sm: {
    word: 'text-lg',
    sub: 'text-[7px] mt-0.5'
  },
  md: {
    word: 'text-[1.6rem]',
    sub: 'text-[8px] mt-1'
  },
  lg: {
    word: 'text-5xl',
    sub: 'text-[11px] mt-2'
  }
};
export function Logo({
  size = 'md',
  className = '',
  sub = 'BEAUTY'
}: LogoProps) {
  const s = sizes[size];
  return <span className={`inline-flex flex-col items-center leading-none ${className}`} data-id="element-26" data-mp="tzsu7ftocaa4">
      <span className={`font-display tracking-[0.12em] ${s.word}`} data-id="element-27" data-mp="yynobdx3dl9j">AMIRA</span>
      {sub && <span className={`pl-[0.6em] font-medium tracking-[0.6em] ${s.sub}`} data-id="element-28" data-mp="z0guks3sm3h0">{sub}</span>}
    </span>;
}